export const defaultBookUrls = [
  'https://www.gutenberg.org/cache/epub/55/pg55-images.html',
  'https://www.gutenberg.org/cache/epub/54/pg54-images.html',
  'https://www.gutenberg.org/cache/epub/33361/pg33361-images.html',
  'https://www.gutenberg.org/cache/epub/22566/pg22566-images.html',
  'https://www.gutenberg.org/cache/epub/26624/pg26624-images.html',
  'https://www.gutenberg.org/cache/epub/41667/pg41667-images.html',
  'https://www.gutenberg.org/cache/epub/32094/pg32094-images.html',
  'https://www.gutenberg.org/cache/epub/75720/pg75720-images.html'
]

export const targetChunkSize = 1200;
export const sentenceOverlap = 3;
export const smallParagraphLength = 300;
export const smallParagraphOverlap = 3;

export const topK = 3;